import { DrillingType } from './drilling'
import { Folding } from './folding'
import { BindingSide } from './bindingSide'
import { Lamination } from './lamination'
import { Cutting } from './cutting'
import { StaplingSide } from './stapling'

export * from '../easyUploadUtils'
export * from './Overlay'
export const overlaysAdapter = {
  DrillingType,
  Folding,
  BindingSide,
  Lamination,
  Cutting,
  StaplingSide,
}






